import type { DBCustomerMonitoringSource, MonitoringSourceKind, SignalFrequency } from "@/lib/db-types";
import type { StatusTone } from "@/lib/widget-status";

export interface MonitoringSourceMeta {
  kind: MonitoringSourceKind;
  label: string;
  placeholder: string;
}

/** Kildene rådgiver kan sette opp per kunde. Brønnøysund er alltid på og har ingen rad. */
export const MONITORING_SOURCES: readonly MonitoringSourceMeta[] = [
  { kind: "website", label: "Nettside", placeholder: "https://kunde.no" },
  { kind: "instagram", label: "Instagram", placeholder: "brukernavn" },
  { kind: "facebook", label: "Facebook", placeholder: "side-adresse eller navn" },
  { kind: "linkedin", label: "LinkedIn", placeholder: "linkedin.com/company/…" },
];

export const FREQUENCY_LABELS: Record<SignalFrequency, string> = {
  weekly: "Ukentlig",
  daily: "Daglig",
};

export type MonitoringMode = "follows_status" | "overridden";

/** Radens modus: følger auto-regelen (override = false) eller satt manuelt. */
export function monitoringMode(row: Pick<DBCustomerMonitoringSource, "override">): MonitoringMode {
  return row.override ? "overridden" : "follows_status";
}

/** Slås bryteren av eller på uten adresse? Uten adresse er det ingenting å hente. */
export function canToggleSource(row: Pick<DBCustomerMonitoringSource, "identifier"> | undefined): boolean {
  return !!row?.identifier?.trim();
}

export interface MonitoringRunStatus {
  tone: StatusTone;
  label: string;
}

/** Driftsstatus per kilde (wireframe: OK, Feil, Av, Venter). Uten rad finnes ingen status. */
export function monitoringRunStatus(
  row: Pick<DBCustomerMonitoringSource, "is_active" | "last_error" | "last_run_at"> | undefined,
): MonitoringRunStatus | null {
  if (!row) return null;
  if (!row.is_active) return { tone: "near", label: "Av" };
  if (row.last_error) return { tone: "miss", label: "Feil" };
  if (row.last_run_at) return { tone: "reached", label: "OK" };
  return { tone: "near", label: "Venter" };
}
